import React from 'react';
import styled from 'styled-components';
import { layout } from 'styled-system';

import CheckLandsButton from '../../atoms/CheckLandsButton';
import Pattern from '../../../assets/pattern.png';
import MaximsLogo from '../../../assets/maxims-logo.png';
import MonopolyTitle from '../../../assets/monopoly-title.png';
import Character from '../../../assets/character.png';
import MonopolyLogo from '../../../assets/Monopoly_Logo_GB.png';

const TopSectionWrapper = styled.div`
  background-image: url(${Pattern});
  padding: 48px 32px 16px 32px;
`;

const ImageSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 48px;
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0px;
  }
`;

const MonopolyLogoWrapper = styled.img`
  width: 40%;
`;

const MaximsLogoWrapper = styled.img`
  width: 40%;
`;

const MonopolyTitleWrapper = styled.img`
  height: 100%;
  ${layout}
`;

const CharacterWrapper = styled.img`
  width: 50%;

  ${layout}
`;

const LargeHeader = () => {
  return (
    <TopSectionWrapper>
      <ImageSection>
        <ImageWrapper>
          <MonopolyLogoWrapper src={MonopolyLogo} />
          <MaximsLogoWrapper src={MaximsLogo} />
        </ImageWrapper>
        <ImageWrapper>
          <MonopolyTitleWrapper src={MonopolyTitle} width={['50%', '40%']} />
          <CharacterWrapper src={Character} width={['50%', '40%']} />
        </ImageWrapper>
      </ImageSection>
      <CheckLandsButton>查看我的地卡</CheckLandsButton>
    </TopSectionWrapper>
  );
};

export default LargeHeader;
